import { render, staticRenderFns } from "./sensitiveWordsModal.vue?vue&type=template&id=77ea9160&scoped=true&"
import script from "./sensitiveWordsModal.vue?vue&type=script&lang=js&"
export * from "./sensitiveWordsModal.vue?vue&type=script&lang=js&"
import style0 from "./sensitiveWordsModal.vue?vue&type=style&index=0&id=77ea9160&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ea9160",
  null
  
)

export default component.exports